import { CommonModule, NgFor } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { FormControl, ReactiveFormsModule } from '@angular/forms'

@Component({
  selector: 'app-tax-calculation-details',
  imports: [NgFor, CommonModule, ReactiveFormsModule],
  templateUrl: './tax-calculation-details.component.html',
  styleUrl: './tax-calculation-details.component.scss'
})
export class TaxCalculationDetailsComponent implements OnInit {
  financialYears: string[] = []
  selectedFinancialYear = new FormControl('', { nonNullable: true })

  ngOnInit(): void {
    this.setupFinancialYears()
    //this.loadBusinessesList()
    //this.listenForSelectionChanges()
    //this.subscribeToPayrollBatches()
    //this.initializePaymentDetailsForm()
  }

  private setupFinancialYears(): void {
    const currentYear = new Date().getFullYear()
    const START_YEAR = 2023 // Adjust as needed

    for (let year = START_YEAR; year <= currentYear + 1; year++) {
      this.financialYears.unshift(`${year - 1}-${year}`)
    }
    if (this.financialYears.length > 0) {
      this.selectedFinancialYear.setValue(this.financialYears[0])
    }
  }
}
